<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-card class="rounded-xl" flat>
        <v-card-title class="justify-center">{{
          $t("dsUserSettings.title")
        }}</v-card-title>
        <v-card-text>
          <div class="rowinfo">
            <v-select
              v-model="computedValue.name"
              :items="translatedItems"
              :menu-props="{ offsetY: true }"
              class="rounded-lg contentinfo"
              dense
              hide-details
              outlined
            />
            <help-info
              :element-name="`${serviceName}-${componentName}-computedValue-name`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              :label="$t('dsUserSettings.labels.minimumCart')"
            />
          </div>
        </v-card-text>

        <template v-if="computedValue.name === 'group'">
          <v-card-title class="justify-center">{{
            $t("dsUserSettings.groupTitle")
          }}</v-card-title>
          <v-card-text>
            <div class="rowinfo">
              <v-select
                v-model="computedValue.group"
                :items="translatedGroupItems"
                :menu-props="{ offsetY: true }"
                class="rounded-lg contentinfo"
                clearable
                dense
                hide-details
                outlined
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-computedValue-group`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('dsUserSettings.labels.users')"
              />
            </div>
          </v-card-text>
        </template>

        <template v-if="computedValue.name === 'special'">
          <v-card-title class="justify-center">{{
            $t("dsUserSettings.specialTitle")
          }}</v-card-title>
          <v-card-text>
            <personal-user-picker v-model="computedValue.special" />
          </v-card-text>
        </template>
      </v-card>
    </template>
  </help-info-wrapper>
</template>

<script>
import PersonalUserPicker from "@/view/components/pickers/personalUserPicker.vue";

export default {
  name: "dsUserSettings",

  components: { PersonalUserPicker },

  props: {
    value: Object,
  },

  data: () => ({
    helpData: [],
    componentName: "dsUserSettings",
    serviceName: "Qrland",
  }),

  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    translatedItems() {
      return [
        { value: "AllUser", text: this.$t("dsUserSettings.items.AllUser") },
        { value: "group", text: this.$t("dsUserSettings.items.group") },
        { value: "special", text: this.$t("dsUserSettings.items.special") },
      ];
    },
    translatedGroupItems() {
      return [
        { value: "Order", text: this.$t("dsUserSettings.groupItems.Order") },
        {
          value: "noOrder",
          text: this.$t("dsUserSettings.groupItems.noOrder"),
        },
      ];
    },
  },

  watch: {
    "$i18n.locale": {
      handler() {
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
    "computedValue.name"(val) {
      if (val === "AllUser")
        this.computedValue = {
          name: "AllUser",
        };
      else
        this.computedValue = {
          name: val,
          [val]: null,
        };
    },
  },
};
</script>

<style scoped></style>
